<template>
	<inertia-head title="Information Approval" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Information Approval</h1>
					<p class="h4 fw-normal text-white-75 fs-sm">Information Approval Management</p>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Filter by</label>
								<select
									v-model="form.filter_column"
									class="form-select form-select-sm"
								>
									<option value="u.username">Email</option>
									<option value="u.fname">First Name</option>
									<option value="u.lname">Last Name</option>
									<option value="u.counter">Member ID</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Search</label>
								<input
									v-model="form.search"
									type="text"
									class="form-control form-control-sm"
								/>
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<label for="" class="form-label"></label>
							<div>
								<button type="submit" class="btn btn-alt-primary me-1">
									<i class="fa fa-search me-1"></i>
									Display
								</button>
								<button
									@click="$inertia.visit(route('admin.investments.information-approval'))"
									type="button"
									class="btn btn-alt-secondary"
								>
									<i class="fa fa-retweet me-1"></i>
									Reset
								</button>
							</div>
						</div>
					</div>

				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>SOURCE</th>
								<th>NAME</th>
								<th>SUBSCRIPTION</th>
								<th>EXPIRY</th>
								<th>MOBILE</th>
								<th>REMARK</th>
								<th>STATUS</th>
								<th class="text-end">::::</th>
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(approval, index) in approvals.data"
								:key="approval.invest_uuid"
							>
								<td>{{approval.invest_source}}</td>
								<td>
									{{approval.fname}} {{approval.lname}}
									<div><sub class="text-info">{{approval.username}}</sub></div>
								</td>
								<td>{{approval.current_rank}}</td>
								<td>{{approval.expiry}}</td>
								<td>{{approval.mobile}}</td>
								<td>
									<span :class="{'text-success':approval.is_verified==1,'text-warning':approval.is_verified==0 && approval.info_complete==1 && approval.risk_investor_type!==null,'text-danger':approval.is_docu_rejected==1}">{{approval.status}}</span>
									<div v-if="approval.is_docu_reupload==1">(<span class="text-warning">Re-upload</span>)</div>
								</td>
								<td>
									<span v-if="approval.invest_uid==null" class="text-warning">Pending</span>
								</td>
								<td class="text-end">
									<button @click="modalToggle(index)" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-search"></i></button>
								</td>
							</tr>
							<tr v-if="approvals.data.length == 0">
								<td colspan="8" class="text-center text-danger p-3">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="approvals" />
			</div>
		</div>

		<information-approval-modal ref="informationApporvalModal" :api-response="api_response"></information-approval-modal>

	</div>
</template>

<script>
import { onMounted, watch, ref } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { useForm } from '@inertiajs/inertia-vue3';
import InformationApprovalModal from '../../../Components/Admin/Investments/InformationApprovalModal';
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		approvals 		: Object,
		filter_column 	: String,
		search 			: String,
		api_response 	: Object,
		errors		 	: Object
	},
	components:{InformationApprovalModal},
	setup(props) {
		const action = ref('verify');
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const informationApporvalModal = ref(null);

		const form = useForm({
			filter_column 	: props.filter_column,
			search 			: props.search,
		})

		const submit = () => {
			form.get(route('admin.investments.information-approval'), {
				preserveState: true,
				preserveScroll: true,
				only:['approvals']
			})
		}

		const selectedMember = ref(null);

		const modalToggle = (_index)=>{

			selectedMember.value = props.approvals.data[_index];

			informationApporvalModal.value.setMember(selectedMember.value);

			informationApporvalModal.value.toggleModal();
		}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{	
				if(value.result=="success")
				{	
					var action_msg = informationApporvalModal.value.action=='reject'?'rejected':'verified';
					var action_msg1= "";
					if(value.data.ok==false)
					{
						action_msg1 = " and the data posting is " + value.data.message+".";
					}

					toast.show("Successfully "+action_msg+action_msg1, { type: value.result});
				}else
				{
					if(informationApporvalModal.value.action=="repost")
					{
						toast.show("Failed to repost the data.", { type: "error"});
					}else
					{
						toast.show("Failed to "+informationApporvalModal.value.action, { type: "error"});	
					}
					
				}
			}
		})

		return {
			action,
			form,
			submit,
			selectedMember,
			informationApporvalModal,
			modalToggle
		}
	},
}
</script>
